import React from 'react';
import FiduciaLogo from '../../../../../../../../../assets/images/fiducia-logo.jpg';
import {
  celMaskPhone,
  cpfCnpjMask,
} from '../../../../../../../../../utils/masks';

function PdfGlobal(props: any) {
  const { ctx } = props;
  return (
    <div style={{ width: '740px', margin: 'auto' }}>
      <div
        className="WordSection4"
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <p style={{ padding: '0 0 0 25pt' }}>
          <span style={{ lineHeight: '26pt' }}>FICHA CADASTRAL</span>
          <br />
          <b style={{ fontSize: '20pt', lineHeight: '26pt' }}>
            PESSOA JURÍDICA -
          </b>
          <br />
          <b style={{ fontSize: '20pt', lineHeight: '26pt' }}>
            ABERTURA DE CONTA
          </b>
        </p>
        <img
          src={FiduciaLogo}
          alt="Fidúcia Logo"
          height={82}
          width={300}
          style={{ objectFit: 'contain', objectPosition: 'center' }}
        />
      </div>
      <span style={{ fontSize: '12.0pt', fontFamily: '"Cambria",serif' }}>
        <br style={{ pageBreakBefore: 'auto' }} />
      </span>
      <div className="WordSection6">
        <table
          style={{
            marginLeft: '22pt',
            borderCollapse: 'collapse',
            border: 'none',
            width: '740px',
          }}
          width={740}
          cellSpacing={0}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: '8.0pt' }}>
              <td
                rowSpan={2}
                style={{
                  background: '#FBFBFB',
                  border: 'solid windowtext 1.0pt',
                }}>
                <p
                  style={{
                    marginLeft: '1.7pt',
                    textAlign: 'center',
                    lineHeight: '19.0pt',
                  }}>
                  <b>
                    <span style={{ color: 'black' }}>
                      Uso exclusivo <br />
                      Fiducia SCMEPP
                    </span>
                  </b>
                </p>
              </td>
              <td
                style={{
                  border: 'solid windowtext 1.0pt',
                  borderLeft: 'none',
                  background: '#FBFBFB',
                  padding: '5px',
                  height: '8.0pt',
                }}>
                <p style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: '8.0pt', color: 'black' }}>
                    Processo
                  </span>
                </p>
              </td>
              <td
                style={{
                  border: 'solid windowtext 1.0pt',
                  borderLeft: 'none',
                  background: '#FBFBFB',
                  padding: '5px',
                  height: '8.0pt',
                }}>
                <p style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: '8.0pt', color: 'black' }}>
                    Tipo de cliente
                  </span>
                </p>
              </td>
              <td
                style={{
                  border: 'solid windowtext 1.0pt',
                  borderLeft: 'none',
                  background: '#FBFBFB',
                  padding: '0in 5.4pt 0in 5.4pt',
                  height: '8.0pt',
                }}>
                <p style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: '8.0pt', color: 'black' }}>
                    Código do Cliente
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '29.25pt' }}>
              <td
                style={{
                  width: '148.65pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: '#FBFBFB',
                  padding: '0in 5.4pt 0in 5.4pt',
                  height: '29.25pt',
                }}
                width={198}>
                <p
                  style={{
                    fontSize: '7.5pt',
                    color: 'black',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}>
                  <span
                    style={{
                      display: 'block',
                      height: 10,
                      width: 10,
                      border: '1px solid #000',
                      marginRight: '5pt',
                      marginLeft: '5pt',
                    }}
                  />{' '}
                  Abertura
                  <span
                    style={{
                      display: 'block',
                      height: 10,
                      width: 10,
                      marginLeft: '5pt',
                      border: '1px solid #000',
                      marginRight: '5pt',
                    }}
                  />{' '}
                  Atualização
                </p>
              </td>
              <td
                style={{
                  width: '160pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: '#FBFBFB',
                  padding: '0in 5.4pt 0in 5.4pt',
                  height: '29.25pt',
                }}
                width={133}
                valign="top">
                <p
                  style={{
                    fontSize: '7.5pt',
                    color: 'black',
                    display: 'flex',
                    alignContent: 'center',
                    alignItems: 'center',
                    height: 38,
                  }}>
                  <span
                    style={{
                      display: 'block',
                      height: 10,
                      width: 10,
                      border: '1px solid #000',
                      marginRight: '5pt',
                      marginLeft: '5pt',
                    }}
                  />
                  Contratante
                  <span
                    style={{
                      display: 'block',
                      height: 10,
                      width: 10,
                      marginLeft: '5pt',
                      border: '1px solid #000',
                      marginRight: '5pt',
                    }}
                  />
                  Agente Fiduciário
                </p>
              </td>
              <td
                style={{
                  width: '90pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: '#FBFBFB',
                  padding: '0in 5.4pt 0in 5.4pt',
                  height: '29.25pt',
                }}
                width={133}
                valign="top">
                <p style={{ lineHeight: '19.0pt' }}>&nbsp;</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span style={{ fontSize: '12.0pt', fontFamily: '"Cambria",serif' }}>
        <br style={{ pageBreakBefore: 'auto' }} />
      </span>
      <div className="WordSection8">
        <p style={{ marginLeft: '26.4pt' }}>
          <b style={{ fontSize: '10pt', lineHeight: '18pt' }}>
            DADOS CORPORATIVOS
          </b>
        </p>
      </div>
      <div className="WordSection9">
        <table
          className="MsoNormalTable"
          style={{
            marginLeft: '24.9pt',
            borderCollapse: 'collapse',
            width: '740px',
          }}
          width={740}
          cellSpacing={0}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: '26.25pt' }}>
              <td
                colSpan={5}
                style={{
                  width: '399.85pt',
                  border: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '26.25pt',
                }}
                width={533}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Denominação / Razão Social:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                      letterSpacing: '.1pt',
                    }}>
                    {ctx.companyName}
                  </b>
                </p>
              </td>
              <td
                style={{
                  width: '146.9pt',
                  border: 'solid black 1.0pt',
                  borderLeft: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.25pt',
                }}
                width={196}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '10pt',
                      color: 'black',
                      letterSpacing: '-.4pt',
                    }}>
                    CNPJ:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {cpfCnpjMask(ctx.cpfCnpj)}
                  </b>
                </p>
              </td>
            </tr>
            <tr style={{ height: '26.75pt' }}>
              <td
                colSpan={6}
                style={{
                  width: '546.75pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.75pt',
                }}
                width={729}
                valign="middle">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Nome Fantasia:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.companyName}
                  </b>
                </p>
                <p />
              </td>
            </tr>
            <tr style={{ height: '25.6pt' }}>
              <td
                colSpan={2}
                style={{
                  width: '121.25pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={162}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Data de Fundação:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.birthday}
                  </b>
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  width: '214.85pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={286}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    País de Origem:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}
                  />
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  width: '210.65pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '25.6pt',
                }}
                width={281}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Município de Fundação:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.city} / {ctx.country}
                  </b>
                </p>
              </td>
            </tr>
            <tr style={{ height: '29.05pt' }}>
              <td
                colSpan={2}
                style={{
                  width: '121.25pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '29.05pt',
                }}
                width={162}
                valign="middle">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Forma de Constituição:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    ?
                  </b>
                </p>
              </td>
              <td
                colSpan={4}
                style={{
                  width: '425.5pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '29.05pt',
                }}
                width={567}
                valign="middle">
                <p
                  style={{
                    fontSize: '9pt',
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  Atividade Principal: <br />
                </p>
              </td>
            </tr>
            <tr style={{ height: '28.9pt' }}>
              <td
                style={{
                  width: '101.0pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '28.9pt',
                }}
                width={135}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Telefone:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {celMaskPhone(ctx.phone)}
                  </b>
                </p>
              </td>
              <td
                colSpan={2}
                style={{
                  width: '101.25pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '28.9pt',
                }}
                width={135}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Celular:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.cel
                      .replace(/(\d{2})(\d)/, '($1) $2')
                      .replace(/(\d)(\d{4})$/, '$1-$2')}
                  </b>
                </p>
              </td>
              <td
                colSpan={3}
                style={{
                  width: '344.5pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '28.9pt',
                }}
                width={459}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    E-mail:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.email}
                  </b>
                </p>
                <p />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p style={{ lineHeight: '30px' }}>&nbsp;</p>
      <p style={{ marginLeft: '25pt' }}>
        <b style={{ fontSize: '10pt' }}>
          DADOS DE ENDEREÇO PARA CORRESPONDÊNCIA
        </b>
        <br />
        <span style={{ color: '#686868', fontSize: '9pt', lineHeight: '18pt' }}>
          Deverá ser apresentado o comprovante para o respectivo endereço{' '}
        </span>
      </p>
      <div className="WordSection12">
        <table
          className="MsoNormalTable"
          style={{
            marginLeft: '24.9pt',
            borderCollapse: 'collapse',
            width: '740px',
          }}
          width={740}
          cellSpacing={0}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: '26.5pt' }}>
              <td
                colSpan={2}
                style={{
                  width: '381.5pt',
                  border: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '26.5pt',
                }}
                width={509}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Logradouro:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.publicPlace}
                  </b>
                </p>
              </td>
              <td
                style={{
                  width: '64.5pt',
                  border: 'solid black 1.0pt',
                  borderLeft: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.5pt',
                }}
                width={86}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Número:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.number}
                  </b>
                </p>
              </td>
              <td
                style={{
                  width: '100.75pt',
                  border: 'solid black 1.0pt',
                  borderLeft: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '26.5pt',
                }}
                width={134}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Complemento:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.complement}
                  </b>
                </p>
              </td>
            </tr>
            <tr style={{ height: '27.25pt' }}>
              <td
                style={{
                  width: '198.5pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '27.25pt',
                }}
                width={265}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Bairro:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.district}
                  </b>
                </p>
              </td>
              <td
                style={{
                  width: '183.0pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '27.25pt',
                }}
                width={244}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    Cidade:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.city}
                  </b>
                </p>
              </td>
              <td
                style={{
                  width: '64.5pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '27.25pt',
                }}
                width={86}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    UF:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.country}
                  </b>
                </p>
              </td>
              <td
                style={{
                  width: '100.75pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '27.25pt',
                }}
                width={134}
                valign="top">
                <p
                  style={{
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  <span
                    style={{
                      fontSize: '7.5pt',
                      color: 'black',
                      letterSpacing: '.15pt',
                    }}>
                    CEP:
                  </span>
                  <br />
                  <b
                    style={{
                      fontSize: '10pt',
                      lineHeight: '104%',
                      color: 'black',
                    }}>
                    {ctx.cep}
                  </b>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p style={{ lineHeight: '30px' }}>&nbsp;</p>
      <div className="WordSection8">
        <p style={{ marginLeft: '26.4pt' }}>
          <b style={{ fontSize: '8.5pt' }}>SITUAÇÃO FINANCEIRA PATRIMONIAL</b>
        </p>
      </div>
      <div className="WordSection14">
        <table
          className="MsoNormalTable"
          style={{
            marginLeft: '23.9pt',
            borderCollapse: 'collapse',
            width: '740px',
          }}
          width={740}
          cellSpacing={0}
          cellPadding={0}>
          <tbody>
            <tr style={{ height: '.25in' }}>
              <td
                style={{
                  width: '383.0pt',
                  border: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '.25in',
                }}
                width={511}
                valign="top">
                <p
                  style={{
                    fontSize: '9pt',
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  Faturamento dos últimos 12 meses
                  <small>(somatório consolidado)</small>
                </p>
              </td>
              <td
                style={{
                  width: '164.0pt',
                  border: 'solid black 1.0pt',
                  borderLeft: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '.25in',
                }}
                width={219}
                valign="middle"
              />
            </tr>
            <tr style={{ height: '.25in' }}>
              <td
                style={{
                  width: '383.0pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '.25in',
                }}
                width={511}
                valign="top">
                <p
                  style={{
                    fontSize: '9pt',
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  Bens móveis <small>(carro, moto, etc.)</small>
                </p>
              </td>
              <td
                style={{
                  width: '164.0pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '.25in',
                }}
                width={219}
                valign="middle"
              />
            </tr>
            <tr style={{ height: '16.45pt' }}>
              <td
                style={{
                  width: '383.0pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '16.45pt',
                }}
                width={511}
                valign="top">
                <p
                  style={{
                    fontSize: '9pt',
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  Bens imóveis
                  <small>
                    (casa, terreno, apartamento, sala comercial etc.)
                  </small>
                </p>
              </td>
              <td
                style={{
                  width: '164.0pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '16.45pt',
                }}
                width={219}
                valign="top"
              />
            </tr>
            <tr style={{ height: '17.6pt' }}>
              <td
                style={{
                  width: '383.0pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '17.6pt',
                }}
                width={511}
                valign="top">
                <p
                  style={{
                    fontSize: '9pt',
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  Aplicações financeiras / Conta corrente
                  <small>
                    (montante em conta corrente, ações, títulos de renda fixa,
                    fundos,etc.)
                  </small>
                </p>
              </td>
              <td
                style={{
                  width: '164.0pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '18.95pt',
                }}
                width={219}
                valign="top"
              />
            </tr>
            <tr style={{ height: '18.95pt' }}>
              <td
                style={{
                  width: '383.0pt',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '0in 0in 0in 0in',
                  height: '18.95pt',
                }}
                width={511}
                valign="top">
                <p
                  style={{
                    fontSize: '9pt',
                    marginRight: '0in',
                    marginBottom: '0in',
                    marginLeft: '3.25pt',
                    padding: '5pt',
                  }}>
                  Outros rendimentos
                </p>
              </td>
              <td
                style={{
                  width: '164.0pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '0in 0in 0in 0in',
                  height: '18.95pt',
                }}
                width={219}
                valign="top"
              />
            </tr>
          </tbody>
        </table>
        <p style={{ lineHeight: '7.5pt' }}>&nbsp;</p>
      </div>
      <span style={{ fontSize: '12.0pt', fontFamily: '"Cambria",serif' }}>
        <br style={{ pageBreakBefore: 'auto' }} />
      </span>
      <p style={{ marginLeft: '25pt', textAlign: 'center' }}>
        <b style={{ fontSize: '10pt', lineHeight: '18pt' }}>DADOS BANCÁRIOS</b>
        <br />
        <span style={{ color: '#686868', fontSize: '9pt' }}>
          Indique as contas bancárias para as suas movimentações financeiras na
          FIDÚCIA SCMEPP. <br />
          Apenas uma conta poderá ser marcada como principal.{' '}
        </span>
      </p>
      <span style={{ fontSize: '12.0pt', fontFamily: '"Cambria",serif' }}>
        <br style={{ pageBreakBefore: 'auto' }} />
      </span>
      <div className="WordSection17">
        <div
          style={{
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'center',
            width: '740px',
            margin: '0 0 0 25pt',
          }}>
          <table
            className="MsoTableGrid"
            style={{
              width: '3.15in',
              borderCollapse: 'collapse',
              border: 'none',
            }}
            width={302}
            cellSpacing={0}
            cellPadding={0}>
            <tbody>
              <tr>
                <td
                  style={{
                    width: '63.8pt',
                    border: 'solid windowtext 1.0pt',
                    padding: '0in 5.4pt 0in 5.4pt',
                  }}
                  width={85}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    Conta Principal
                  </p>
                </td>
                <td
                  style={{
                    width: '49.6pt',
                    border: 'solid windowtext 1.0pt',
                    borderLeft: 'none',
                    padding: '0in 5.4pt 0in 5.4pt',
                  }}
                  width={66}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    Cód/Banco
                  </p>
                </td>
                <td
                  style={{
                    width: '49.65pt',
                    border: 'solid windowtext 1.0pt',
                    borderLeft: 'none',
                    padding: '0in 5.4pt 0in 5.4pt',
                  }}
                  width={66}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    Agência
                  </p>
                </td>
                <td
                  style={{
                    width: '63.75pt',
                    border: 'solid windowtext 1.0pt',
                    borderLeft: 'none',
                    padding: '0in 5.4pt 0in 5.4pt',
                  }}
                  width={85}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    N° Conta
                  </p>
                </td>
              </tr>
              <tr style={{ height: '18.05pt', textAlign: 'center' }}>
                <td
                  style={{
                    width: '63.8pt',
                    border: 'solid windowtext 1.0pt',
                    borderTop: 'none',
                    padding: '0in 5.4pt 0in 5.4pt',
                    height: '18.05pt',
                  }}
                  width={85}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}
                  />
                </td>
                <td
                  style={{
                    width: '49.6pt',
                    borderTop: 'none',
                    borderLeft: 'none',
                    borderBottom: 'solid windowtext 1.0pt',
                    borderRight: 'solid windowtext 1.0pt',
                    padding: '0in 5.4pt 0in 5.4pt',
                    height: '18.05pt',
                  }}
                  width={66}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}
                  />
                </td>
                <td
                  style={{
                    width: '49.65pt',
                    borderTop: 'none',
                    borderLeft: 'none',
                    borderBottom: 'solid windowtext 1.0pt',
                    borderRight: 'solid windowtext 1.0pt',
                    padding: '0in 5.4pt 0in 5.4pt',
                    height: '18.05pt',
                  }}
                  width={66}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}
                  />
                </td>
                <td
                  style={{
                    width: '63.75pt',
                    borderTop: 'none',
                    borderLeft: 'none',
                    borderBottom: 'solid windowtext 1.0pt',
                    borderRight: 'solid windowtext 1.0pt',
                    padding: '0in 5.4pt 0in 5.4pt',
                    height: '18.05pt',
                  }}
                  width={85}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}
                  />
                </td>
              </tr>
              <tr style={{ height: '18.05pt', textAlign: 'center' }}>
                <td
                  style={{
                    width: '63.8pt',
                    border: 'solid windowtext 1.0pt',
                    borderTop: 'none',
                    padding: '0in 5.4pt 0in 5.4pt',
                    height: '18.05pt',
                  }}
                  width={85}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}
                  />
                </td>
                <td
                  style={{
                    width: '49.6pt',
                    borderTop: 'none',
                    borderLeft: 'none',
                    borderBottom: 'solid windowtext 1.0pt',
                    borderRight: 'solid windowtext 1.0pt',
                    padding: '0in 5.4pt 0in 5.4pt',
                    height: '18.05pt',
                  }}
                  width={66}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}
                  />
                </td>
                <td
                  style={{
                    width: '49.65pt',
                    borderTop: 'none',
                    borderLeft: 'none',
                    borderBottom: 'solid windowtext 1.0pt',
                    borderRight: 'solid windowtext 1.0pt',
                    padding: '0in 5.4pt 0in 5.4pt',
                    height: '18.05pt',
                  }}
                  width={66}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}
                  />
                </td>
                <td
                  style={{
                    width: '63.75pt',
                    borderTop: 'none',
                    borderLeft: 'none',
                    borderBottom: 'solid windowtext 1.0pt',
                    borderRight: 'solid windowtext 1.0pt',
                    padding: '0in 5.4pt 0in 5.4pt',
                    height: '18.05pt',
                  }}
                  width={85}>
                  <p
                    style={{
                      fontSize: '9pt',
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p style={{ lineHeight: '30px' }}>&nbsp;</p>
        <p style={{ marginLeft: '25pt' }}>
          <b style={{ fontSize: '10pt', lineHeight: '18pt' }}>
            DADOS DE IDENTIFICAÇÃO DO REPRESENTANTE/ PROCURADOR
          </b>
          <small style={{ fontSize: '7pt' }}>
            <br />
            (SE HOUVER)
          </small>
          <br />
        </p>
        <div className="WordSection19">
          <table
            className="MsoNormalTable"
            style={{
              marginLeft: '25pt',
              borderCollapse: 'collapse',
              width: '740px',
            }}
            width={740}
            cellSpacing={0}
            cellPadding={0}>
            <tbody>
              <tr style={{ height: '26.3pt' }}>
                <td
                  style={{
                    width: '224.45pt',
                    border: 'solid black 1.0pt',
                    padding: '0in 0in 0in 0in',
                    height: '26.3pt',
                  }}
                  width={299}
                  valign="top">
                  <p
                    style={{
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    <span
                      style={{
                        fontSize: '7.5pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.15pt',
                      }}>
                      Nome completo:
                    </span>
                    <br />
                    <b
                      style={{
                        fontSize: '10pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.1pt',
                      }}
                    />
                  </p>
                </td>
                <td
                  style={{
                    width: '168.0pt',
                    border: 'solid black 1.0pt',
                    borderLeft: 'none',
                    padding: '0in 0in 0in 0in',
                    height: '26.3pt',
                  }}
                  width={224}
                  valign="top">
                  <p
                    style={{
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    <span
                      style={{
                        fontSize: '7.5pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.15pt',
                      }}>
                      Nº do documento de identificação:{' '}
                    </span>
                    <br />
                    <b
                      style={{
                        fontSize: '10pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.1pt',
                      }}
                    />
                  </p>
                </td>
                <td
                  style={{
                    width: '144.75pt',
                    border: 'solid black 1.0pt',
                    borderLeft: 'none',
                    padding: '0in 0in 0in 0in',
                    height: '26.3pt',
                  }}
                  width={193}
                  valign="top">
                  <p
                    style={{
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    <span
                      style={{
                        fontSize: '7.5pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.15pt',
                      }}>
                      CPF:{' '}
                    </span>
                    <br />
                    <b
                      style={{
                        fontSize: '10pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.1pt',
                      }}
                    />
                  </p>
                </td>
              </tr>
              <tr style={{ height: '25.65pt' }}>
                <td
                  colSpan={3}
                  style={{
                    width: '537.2pt',
                    border: 'solid black 1.0pt',
                    borderTop: 'none',
                    padding: '0in 0in 0in 0in',
                    height: '25.65pt',
                  }}
                  width={716}
                  valign="top">
                  <p
                    style={{
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    <span
                      style={{
                        fontSize: '7.5pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.15pt',
                      }}>
                      E-mail:{' '}
                    </span>
                    <br />
                    <b
                      style={{
                        fontSize: '10pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.1pt',
                      }}
                    />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <span style={{ fontSize: '12.0pt', fontFamily: '"Cambria",serif' }}>
          <br style={{ pageBreakBefore: 'auto' }} />
        </span>
        <div className="WordSection20">
          <table
            className="MsoNormalTable"
            style={{
              marginLeft: '25pt',
              borderCollapse: 'collapse',
              width: '740px',
            }}
            width={740}
            cellSpacing={0}
            cellPadding={0}>
            <tbody>
              <tr style={{ height: '26.3pt' }}>
                <td
                  style={{
                    width: '224.45pt',
                    border: 'solid black 1.0pt',
                    padding: '0in 0in 0in 0in',
                    height: '26.3pt',
                  }}
                  width={299}
                  valign="top">
                  <p
                    style={{
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    <span
                      style={{
                        fontSize: '7.5pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.15pt',
                      }}>
                      Nome completo:
                    </span>
                    <br />
                    <b
                      style={{
                        fontSize: '10pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.1pt',
                      }}
                    />
                  </p>
                </td>
                <td
                  style={{
                    width: '168.0pt',
                    border: 'solid black 1.0pt',
                    borderLeft: 'none',
                    padding: '0in 0in 0in 0in',
                    height: '26.3pt',
                  }}
                  width={224}
                  valign="top">
                  <p
                    style={{
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    <span
                      style={{
                        fontSize: '7.5pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.15pt',
                      }}>
                      Nº do documento de identificação:{' '}
                    </span>
                    <br />
                    <b
                      style={{
                        fontSize: '10pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.1pt',
                      }}
                    />
                  </p>
                </td>
                <td
                  style={{
                    width: '144.75pt',
                    border: 'solid black 1.0pt',
                    borderLeft: 'none',
                    padding: '0in 0in 0in 0in',
                    height: '26.3pt',
                  }}
                  width={193}
                  valign="top">
                  <p
                    style={{
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    <span
                      style={{
                        fontSize: '7.5pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.15pt',
                      }}>
                      CPF:{' '}
                    </span>
                    <br />
                    <b
                      style={{
                        fontSize: '10pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.1pt',
                      }}
                    />
                  </p>
                </td>
              </tr>
              <tr style={{ height: '25.65pt' }}>
                <td
                  colSpan={3}
                  style={{
                    width: '537.2pt',
                    border: 'solid black 1.0pt',
                    borderTop: 'none',
                    padding: '0in 0in 0in 0in',
                    height: '25.65pt',
                  }}
                  width={716}
                  valign="top">
                  <p
                    style={{
                      marginRight: '0in',
                      marginBottom: '0in',
                      marginLeft: '3.25pt',
                      padding: '5pt',
                    }}>
                    <span
                      style={{
                        fontSize: '7.5pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.15pt',
                      }}>
                      E-mail:
                    </span>
                    <br />
                    <b
                      style={{
                        fontSize: '10pt',
                        lineHeight: '104%',
                        color: 'black',
                        letterSpacing: '.1pt',
                      }}
                    />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p style={{ lineHeight: '30px' }}>&nbsp;</p>
          <div className="WordSection20">
            <div className="WordSection11">
              <p style={{ lineHeight: '5.15pt' }}>&nbsp;</p>
              <p style={{ fontSize: '7pt', paddingLeft: '25pt' }}>
                <b
                  style={{
                    paddingLeft: '3pt',
                    fontSize: '8.5pt',
                    lineHeight: '102%',
                    color: 'black',
                    letterSpacing: '-.1pt',
                  }}>
                  DECLARAÇÃO DO CLIENTE
                </b>
              </p>
            </div>
            <table
              className="MsoTableGrid"
              style={{
                marginLeft: '25pt',
                borderCollapse: 'collapse',
                border: 'none',
                width: '740px',
              }}
              width={740}
              cellSpacing={0}
              cellPadding={0}>
              <tbody>
                <tr style={{ height: '159.15pt' }}>
                  <td
                    style={{
                      width: '700pt',
                      border: 'solid windowtext 1.0pt',
                      padding: '10pt',
                      height: '159.15pt',
                    }}
                    width={700}
                    valign="top">
                    <p style={{ lineHeight: '14pt', fontSize: '9pt' }}>
                      Autorizo a pesquisa dos créditos registrados para o CNPJ
                      informado no SCR – consoante ao previsto na Resolução
                      4.571, do BANCO CENTRAL DO BRASIL – e em demais bureaus de
                      crédito.
                    </p>
                    <p style={{ lineHeight: '14pt', fontSize: '9pt' }}>
                      {' '}
                      Autorizo o compartilhamento dos dados do CNPJ informado
                      com todos os partícipes na operação, que ora contrato com
                      a FIDÚCIA SCMEPP.{' '}
                    </p>
                    <p style={{ lineHeight: '14pt', fontSize: '9pt' }}>
                      {' '}
                      Asseguro que os recursos decorrentes do empréstimo ou
                      financiamento por mim tomado não será destinado a
                      finalidades que possam causar danos socioambientais e/ou
                      projetos em desacordo com as Políticas Nacionais
                      Socioambientais previstas em Lei e normativos do BANCO
                      CENTRAL DO BRASIL, que não utilizarei, de forma direta ou
                      indireta, os recursos disponibilizados para a prática de
                      ato que atente contra o patrimônio público nacional ou
                      estrangeiro, contra princípios da administração pública ou
                      contra os compromissos internacionais assumidos pelo
                      Brasil. Que não destinarei esse recurso para o
                      financiamento de práticas ilícitas, mas sim, que em sua
                      totalidade, esse crédito por mim tomado será utilizado de
                      forma produtiva, buscando retornos tangíveis e
                      intangíveis.
                    </p>
                    <p style={{ lineHeight: '14pt', fontSize: '9pt' }}>
                      {' '}
                      Declaração de Ciência do CET: Declaro receber nessa
                      oportunidade todas as informações acerca do Custo Efetivo
                      Total-CET, porcentagem anual a ser paga na contratação de
                      uma operação de crédito e engloba todos os encargos e
                      despesas incidentes nas operações de crédito, juros
                      remuneratórios, tarifas, seguro, IOF e registro.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p style={{ lineHeight: '4.15pt' }}>&nbsp;</p>
            <table
              className="MsoNormalTable"
              style={{
                marginLeft: '25pt',
                borderCollapse: 'collapse',
                width: '740px',
              }}
              width={740}
              cellSpacing={0}
              cellPadding={0}>
              <tbody>
                <tr style={{ height: '60pt' }}>
                  <td
                    style={{
                      border: 'solid black 1.0pt',
                      padding: 5,
                      height: '.25in',
                    }}
                    width={200}
                    valign="top">
                    <p
                      style={{
                        marginRight: '0in',
                        marginBottom: '0in',
                        marginLeft: '3.25pt',
                      }}>
                      <b style={{ fontSize: '8.5pt', color: 'black' }}>
                        local e Data:
                      </b>
                    </p>
                  </td>
                  <td
                    style={{
                      border: 'solid black 1.0pt',
                      padding: 5,
                      height: '.25in',
                    }}
                    width={500}
                    valign="top">
                    <p
                      style={{
                        marginRight: '0in',
                        marginBottom: '0in',
                        marginLeft: '3.25pt',
                      }}>
                      <b style={{ fontSize: '8.5pt', color: 'black' }}>
                        Assinatura do Proponente
                      </b>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <span style={{ fontSize: '12.0pt', fontFamily: '"Cambria",serif' }}>
            <br style={{ pageBreakBefore: 'auto' }} />
          </span>
          <div className="WordSection21" />
          <span style={{ fontSize: '12.0pt', fontFamily: '"Cambria",serif' }}>
            <br style={{ pageBreakBefore: 'auto' }} />
          </span>
          <div className="WordSection11">
            <p style={{ lineHeight: '5.15pt' }}>&nbsp;</p>
            <p style={{ fontSize: '7pt', paddingLeft: '25pt' }}>
              <b
                style={{
                  paddingLeft: '3pt',
                  fontSize: '8.5pt',
                  lineHeight: '102%',
                  color: 'black',
                  letterSpacing: '-.1pt',
                }}>
                DECLARAÇÃO DO RESPONSÁVEL PELO CADASTRAMENTO
              </b>
              (USO EXCLUSIVO DA FIDÚCIA SCMEPP)
            </p>
          </div>
          <div className="WordSection24">
            <table
              className="MsoNormalTable"
              cellSpacing={0}
              style={{
                marginLeft: '25pt',
                borderCollapse: 'collapse',
                width: '740px',
              }}
              width={740}
              cellPadding={0}>
              <tbody>
                <tr style={{ height: '40pt' }}>
                  <td
                    colSpan={2}
                    style={{
                      width: '546.85pt',
                      border: 'solid black 1.0pt',
                      padding: 5,
                      height: '31.5pt',
                    }}
                    width={729}
                    valign="top">
                    <p
                      style={{
                        marginRight: '0in',
                        marginBottom: '0in',
                        marginLeft: '3.25pt',
                      }}>
                      <span
                        style={{
                          fontSize: '8.5pt',
                          color: 'black',
                          lineHeight: '10pt',
                        }}>
                        Responsabilizo-me pela conferência e exatidão das
                        informações constantes na ficha, bem como pelos
                        elementos de identificação e das demais informações
                        apresentadas.
                      </span>
                    </p>
                  </td>
                </tr>
                <tr style={{ height: '34.15pt' }}>
                  <td
                    style={{
                      width: '272.6pt',
                      border: 'solid black 1.0pt',
                      borderTop: 'none',
                      padding: 5,
                      height: '34.15pt',
                    }}
                    width={363}
                    valign="top">
                    <p
                      style={{
                        marginRight: '0in',
                        marginBottom: '0in',
                        marginLeft: '3.25pt',
                      }}>
                      <span style={{ fontSize: '8pt', color: 'black' }}>
                        Local e data:
                      </span>
                      <br />
                      <span style={{ fontSize: '10pt', color: 'black' }} />
                    </p>
                  </td>
                  <td
                    style={{
                      width: '274.25pt',
                      borderTop: 'none',
                      borderLeft: 'none',
                      borderBottom: 'solid black 1.0pt',
                      borderRight: 'solid black 1.0pt',
                      padding: 5,
                      height: '34.15pt',
                    }}
                    width={366}
                    valign="top">
                    <p
                      style={{
                        marginRight: '0in',
                        marginBottom: '0in',
                        marginLeft: '3.25pt',
                      }}>
                      <span style={{ fontSize: '8pt', color: 'black' }}>
                        Departamento de Normas FIDÚCIA SCMEPP:
                      </span>
                      <br />
                      <span style={{ fontSize: '10pt', color: 'black' }} />
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PdfGlobal;
